<template>
    <span v-if="countView" class="badge">{{ countView }}</span>
</template>

<script>
import { computed } from "vue";

export default {
    name: "factsheet-badge",
    props: {
        count: {
            type: Number,
            default: null,
        },
    },
    setup(props) {
        const countView = computed(() => {
            return props.count;
        });

        return {
            countView,
        };
    },
};
</script>

<style scoped></style>
